import React, { useMemo, useState } from "react";
import {
    Search,
    Filter,
    Eye,
    X,
    ChevronDown,
    RotateCcw,
    Heart,
    CheckCircle,
    Clock,
    XCircle,
    User,
} from "lucide-react";

const initialMatches = [
    {
        id: 1,
        matchId: "MAT10001",

        memberId: "JP10001",
        memberName: "Arun Kumar",
        memberGender: "Male",
        memberAge: 34,

        matchedMemberId: "JP10008",
        matchedMemberName: "Divya S",
        matchedGender: "Female",
        matchedAge: 30,

        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",

        education: "B.E",
        profession: "Software Engineer",

        branch: "Erode Main Branch",
        state: "Tamil Nadu",
        district: "Erode",

        matchPercentage: 92,
        horoscope: "Good Match",

        maritalStatus: "Unmarried",
        status: "Accepted",

        createdDate: "2026-10-05",
    },

    {
        id: 2,
        matchId: "MAT10002",

        memberId: "JP10002",
        memberName: "Priya Devi",
        memberGender: "Female",
        memberAge: 31,

        matchedMemberId: "JP10009",
        matchedMemberName: "Karthik R",
        matchedGender: "Male",
        matchedAge: 34,

        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",

        education: "M.Com",
        profession: "Accountant",

        branch: "Coimbatore Branch",
        state: "Tamil Nadu",
        district: "Coimbatore",

        matchPercentage: 87,
        horoscope: "Good Match",

        maritalStatus: "Unmarried",
        status: "Pending",

        createdDate: "2026-10-05",
    },

    {
        id: 3,
        matchId: "MAT10003",

        memberId: "JP10003",
        memberName: "Suresh Kumar",
        memberGender: "Male",
        memberAge: 36,

        matchedMemberId: "JP10010",
        matchedMemberName: "Kavitha R",
        matchedGender: "Female",
        matchedAge: 29,

        community: "Naidu",
        subCommunity: "Balija",
        caste: "Naidu",

        education: "MBA",
        profession: "Business",

        branch: "Salem Branch",
        state: "Tamil Nadu",
        district: "Salem",

        matchPercentage: 76,
        horoscope: "Average Match",

        maritalStatus: "Unmarried",
        status: "New",

        createdDate: "2026-10-04",
    },

    {
        id: 4,
        matchId: "MAT10004",

        memberId: "JP10004",
        memberName: "Kavitha R",
        memberGender: "Female",
        memberAge: 28,

        matchedMemberId: "JP10011",
        matchedMemberName: "Vignesh M",
        matchedGender: "Male",
        matchedAge: 31,

        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",

        education: "B.Sc",
        profession: "HR Executive",

        branch: "Tiruppur Branch",
        state: "Tamil Nadu",
        district: "Tiruppur",

        matchPercentage: 81,
        horoscope: "Good Match",

        maritalStatus: "Unmarried",
        status: "Rejected",

        createdDate: "2026-10-03",
    },

    {
        id: 5,
        matchId: "MAT10005",

        memberId: "JP10005",
        memberName: "Vignesh M",
        memberGender: "Male",
        memberAge: 32,

        matchedMemberId: "JP10012",
        matchedMemberName: "Harini S",
        matchedGender: "Female",
        matchedAge: 27,

        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",

        education: "B.Tech",
        profession: "IT Professional",

        branch: "Erode Main Branch",
        state: "Tamil Nadu",
        district: "Erode",

        matchPercentage: 95,
        horoscope: "Excellent Match",

        maritalStatus: "Unmarried",
        status: "New",

        createdDate: "2026-10-02",
    },
];

const emptyFilters = {
    branch: "",
    state: "",
    district: "",
    community: "",
    subCommunity: "",
    caste: "",
    gender: "",
    maritalStatus: "",
    education: "",
    profession: "",
    horoscope: "",
    status: "",
};

function Matches() {
    const [matches] = useState(initialMatches);

    const [searchType, setSearchType] = useState("matchId");
    const [searchText, setSearchText] = useState("");

    const [filters, setFilters] = useState(emptyFilters);
    const [showFilters, setShowFilters] = useState(true);

    const [viewMatch, setViewMatch] = useState(null);

    const filteredMatches = useMemo(() => {
        return matches.filter((match) => {
            const searchValue = searchText
                .toLowerCase()
                .trim();

            let searchMatch = true;

            if (searchValue) {
                if (searchType === "matchId") {
                    searchMatch = match.matchId
                        .toLowerCase()
                        .includes(searchValue);
                }

                if (searchType === "memberId") {
                    searchMatch =
                        match.memberId
                            .toLowerCase()
                            .includes(searchValue) ||
                        match.matchedMemberId
                            .toLowerCase()
                            .includes(searchValue);
                }

                if (searchType === "name") {
                    searchMatch =
                        match.memberName
                            .toLowerCase()
                            .includes(searchValue) ||
                        match.matchedMemberName
                            .toLowerCase()
                            .includes(searchValue);
                }

                if (searchType === "mobile") {
                    // Mobile search can be connected to API
                    // when member data is available.
                    searchMatch = true;
                }
            }

            const filterMatch =
                (!filters.branch ||
                    match.branch === filters.branch) &&
                (!filters.state ||
                    match.state === filters.state) &&
                (!filters.district ||
                    match.district === filters.district) &&
                (!filters.community ||
                    match.community === filters.community) &&
                (!filters.subCommunity ||
                    match.subCommunity ===
                        filters.subCommunity) &&
                (!filters.caste ||
                    match.caste === filters.caste) &&
                (!filters.gender ||
                    match.memberGender === filters.gender) &&
                (!filters.maritalStatus ||
                    match.maritalStatus ===
                        filters.maritalStatus) &&
                (!filters.education ||
                    match.education === filters.education) &&
                (!filters.profession ||
                    match.profession === filters.profession) &&
                (!filters.horoscope ||
                    match.horoscope === filters.horoscope) &&
                (!filters.status ||
                    match.status === filters.status);

            return searchMatch && filterMatch;
        });
    }, [matches, searchText, searchType, filters]);

    const clearFilters = () => {
        setSearchText("");
        setFilters(emptyFilters);
    };

    const uniqueValues = (key) => {
        return [
            ...new Set(matches.map((item) => item[key])),
        ];
    };

    const totalMatches = matches.length;

    const newMatches = matches.filter(
        (item) => item.status === "New"
    ).length;

    const acceptedMatches = matches.filter(
        (item) => item.status === "Accepted"
    ).length;

    const pendingMatches = matches.filter(
        (item) => item.status === "Pending"
    ).length;

    const rejectedMatches = matches.filter(
        (item) => item.status === "Rejected"
    ).length;

    return (
        <div className="matches-page">

            {/* HEADER */}

            <div className="page-header">

                <div>
                    <h1>Matches</h1>

                    <p>
                        Manage matrimonial profile matches
                    </p>
                </div>

            </div>

            {/* SUMMARY */}

            <div className="match-summary">

                <div className="match-summary-card">

                    <div className="match-summary-icon blue">
                        <Heart size={20} />
                    </div>

                    <div>
                        <span>Total Matches</span>
                        <strong>{totalMatches}</strong>
                    </div>

                </div>

                <div className="match-summary-card">

                    <div className="match-summary-icon purple">
                        <Heart size={20} />
                    </div>

                    <div>
                        <span>New Matches</span>
                        <strong>{newMatches}</strong>
                    </div>

                </div>

                <div className="match-summary-card">

                    <div className="match-summary-icon green">
                        <CheckCircle size={20} />
                    </div>

                    <div>
                        <span>Accepted</span>
                        <strong>{acceptedMatches}</strong>
                    </div>

                </div>

                <div className="match-summary-card">

                    <div className="match-summary-icon orange">
                        <Clock size={20} />
                    </div>

                    <div>
                        <span>Pending</span>
                        <strong>{pendingMatches}</strong>
                    </div>

                </div>

                <div className="match-summary-card">

                    <div className="match-summary-icon red">
                        <XCircle size={20} />
                    </div>

                    <div>
                        <span>Rejected</span>
                        <strong>{rejectedMatches}</strong>
                    </div>

                </div>

            </div>

            {/* SEARCH + FILTER */}

            <div className="match-filter-card">

                <div className="match-search-row">

                    <div className="match-search-type">

                        <select
                            value={searchType}
                            onChange={(e) =>
                                setSearchType(
                                    e.target.value
                                )
                            }
                        >
                            <option value="matchId">
                                Match ID
                            </option>

                            <option value="memberId">
                                Member ID
                            </option>

                            <option value="name">
                                Member Name
                            </option>

                            <option value="mobile">
                                Mobile Number
                            </option>
                        </select>

                    </div>

                    <div className="match-search-box">

                        <Search size={18} />

                        <input
                            type="text"
                            placeholder={
                                searchType === "matchId"
                                    ? "Search Match ID..."
                                    : searchType === "memberId"
                                    ? "Search Member ID..."
                                    : searchType === "name"
                                    ? "Search Member Name..."
                                    : "Search Mobile Number..."
                            }
                            value={searchText}
                            onChange={(e) =>
                                setSearchText(
                                    e.target.value
                                )
                            }
                        />

                        {searchText && (
                            <button
                                className="match-search-clear"
                                onClick={() =>
                                    setSearchText("")
                                }
                            >
                                <X size={16} />
                            </button>
                        )}

                    </div>

                    <button
                        className="match-filter-btn"
                        onClick={() =>
                            setShowFilters(
                                !showFilters
                            )
                        }
                    >
                        <Filter size={17} />
                        Filters

                        <ChevronDown
                            size={16}
                            className={
                                showFilters
                                    ? "rotate-180"
                                    : ""
                            }
                        />
                    </button>

                    <button
                        className="match-reset-btn"
                        onClick={clearFilters}
                    >
                        <RotateCcw size={16} />
                        Reset
                    </button>

                </div>

                {showFilters && (
                    <div className="match-filter-grid">

                        <MatchFilter
                            label="Branch"
                            value={filters.branch}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    branch: value,
                                })
                            }
                            options={uniqueValues("branch")}
                        />

                        <MatchFilter
                            label="State"
                            value={filters.state}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    state: value,
                                    district: "",
                                })
                            }
                            options={uniqueValues("state")}
                        />

                        <MatchFilter
                            label="District"
                            value={filters.district}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    district: value,
                                })
                            }
                            options={uniqueValues("district")}
                        />

                        <MatchFilter
                            label="Community"
                            value={filters.community}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    community: value,
                                    subCommunity: "",
                                })
                            }
                            options={uniqueValues("community")}
                        />

                        <MatchFilter
                            label="Sub Community"
                            value={filters.subCommunity}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    subCommunity: value,
                                })
                            }
                            options={uniqueValues(
                                "subCommunity"
                            )}
                        />

                        <MatchFilter
                            label="Caste"
                            value={filters.caste}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    caste: value,
                                })
                            }
                            options={uniqueValues("caste")}
                        />

                        <MatchFilter
                            label="Gender"
                            value={filters.gender}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    gender: value,
                                })
                            }
                            options={[
                                "Male",
                                "Female",
                            ]}
                        />

                        <MatchFilter
                            label="Marital Status"
                            value={
                                filters.maritalStatus
                            }
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    maritalStatus:
                                        value,
                                })
                            }
                            options={[
                                "Unmarried",
                                "Divorced",
                                "Widow",
                                "Widower",
                            ]}
                        />

                        <MatchFilter
                            label="Education"
                            value={filters.education}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    education: value,
                                })
                            }
                            options={uniqueValues(
                                "education"
                            )}
                        />

                        <MatchFilter
                            label="Profession"
                            value={filters.profession}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    profession: value,
                                })
                            }
                            options={uniqueValues(
                                "profession"
                            )}
                        />

                        <MatchFilter
                            label="Horoscope"
                            value={filters.horoscope}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    horoscope: value,
                                })
                            }
                            options={uniqueValues(
                                "horoscope"
                            )}
                        />

                        <MatchFilter
                            label="Match Status"
                            value={filters.status}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    status: value,
                                })
                            }
                            options={[
                                "New",
                                "Pending",
                                "Accepted",
                                "Rejected",
                            ]}
                        />

                    </div>
                )}

            </div>

            {/* TABLE */}

            <div className="matches-table-card">

                <div className="match-table-header">

                    <div>
                        <h2>Match List</h2>

                        <span>
                            Showing{" "}
                            {filteredMatches.length}{" "}
                            of {matches.length} matches
                        </span>
                    </div>

                </div>

                <div className="matches-table-wrapper">

                    <table className="matches-table">

                        <thead>

                            <tr>

                                <th>S.No</th>

                                <th>Match ID</th>

                                <th>Member</th>

                                <th>Matched Profile</th>

                                <th>Age</th>

                                <th>Community</th>

                                <th>Sub Community</th>

                                <th>Caste</th>

                                <th>Education</th>

                                <th>Profession</th>

                                <th>Branch</th>

                                <th>Match %</th>

                                <th>Horoscope</th>

                                <th>Status</th>

                                <th>Created Date</th>

                                <th>Action</th>

                            </tr>

                        </thead>

                        <tbody>

                            {filteredMatches.length === 0 ? (
                                <tr>

                                    <td
                                        colSpan="16"
                                        className="match-empty-table"
                                    >
                                        No matches found
                                    </td>

                                </tr>
                            ) : (
                                filteredMatches.map(
                                    (match, index) => (
                                        <tr
                                            key={
                                                match.id
                                            }
                                        >

                                            <td>
                                                {index + 1}
                                            </td>

                                            <td>
                                                <span className="match-id">
                                                    {
                                                        match.matchId
                                                    }
                                                </span>
                                            </td>

                                            <td>

                                                <div className="match-person">

                                                    <div className="match-avatar male-avatar">
                                                        {match.memberName
                                                            .charAt(
                                                                0
                                                            )
                                                            .toUpperCase()}
                                                    </div>

                                                    <div>
                                                        <strong>
                                                            {
                                                                match.memberName
                                                            }
                                                        </strong>

                                                        <small>
                                                            {
                                                                match.memberId
                                                            }
                                                        </small>
                                                    </div>

                                                </div>

                                            </td>

                                            <td>

                                                <div className="match-person">

                                                    <div className="match-avatar female-avatar">
                                                        {match.matchedMemberName
                                                            .charAt(
                                                                0
                                                            )
                                                            .toUpperCase()}
                                                    </div>

                                                    <div>
                                                        <strong>
                                                            {
                                                                match.matchedMemberName
                                                            }
                                                        </strong>

                                                        <small>
                                                            {
                                                                match.matchedMemberId
                                                            }
                                                        </small>
                                                    </div>

                                                </div>

                                            </td>

                                            <td>
                                                <span className="age-value">
                                                    {
                                                        match.memberAge
                                                    }{" "}
                                                    /{" "}
                                                    {
                                                        match.matchedAge
                                                    }
                                                </span>
                                            </td>

                                            <td>
                                                {
                                                    match.community
                                                }
                                            </td>

                                            <td>
                                                {
                                                    match.subCommunity
                                                }
                                            </td>

                                            <td>
                                                {match.caste}
                                            </td>

                                            <td>
                                                {match.education}
                                            </td>

                                            <td>
                                                {match.profession}
                                            </td>

                                            <td>
                                                {match.branch}
                                            </td>

                                            <td>

                                                <div className="match-score">

                                                    <div className="match-score-bar">

                                                        <span
                                                            style={{
                                                                width: `${match.matchPercentage}%`,
                                                            }}
                                                        />

                                                    </div>

                                                    <strong>
                                                        {
                                                            match.matchPercentage
                                                        }
                                                        %
                                                    </strong>

                                                </div>

                                            </td>

                                            <td>
                                                <span
                                                    className={`horoscope-match ${match.horoscope
                                                        .toLowerCase()
                                                        .replaceAll(
                                                            " ",
                                                            "-"
                                                        )}`}
                                                >
                                                    {
                                                        match.horoscope
                                                    }
                                                </span>
                                            </td>

                                            <td>
                                                <span
                                                    className={`match-status ${match.status.toLowerCase()}`}
                                                >
                                                    {
                                                        match.status
                                                    }
                                                </span>
                                            </td>

                                            <td>
                                                {
                                                    match.createdDate
                                                }
                                            </td>

                                            <td>

                                                <button
                                                    className="match-view-btn"
                                                    title="View Match"
                                                    onClick={() =>
                                                        setViewMatch(
                                                            match
                                                        )
                                                    }
                                                >
                                                    <Eye
                                                        size={
                                                            17
                                                        }
                                                    />
                                                </button>

                                            </td>

                                        </tr>
                                    )
                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* VIEW MATCH MODAL */}

            {viewMatch && (
                <div className="match-modal-overlay">

                    <div className="match-view-modal">

                        <div className="match-modal-header">

                            <div>
                                <h2>
                                    Match Details
                                </h2>

                                <p>
                                    {
                                        viewMatch.matchId
                                    }
                                </p>
                            </div>

                            <button
                                onClick={() =>
                                    setViewMatch(
                                        null
                                    )
                                }
                            >
                                <X size={20} />
                            </button>

                        </div>

                        {/* PROFILE COMPARISON */}

                        <div className="match-profile-comparison">

                            <div className="match-profile-card">

                                <div className="match-large-avatar male-avatar">
                                    {viewMatch.memberName
                                        .charAt(0)
                                        .toUpperCase()}
                                </div>

                                <h3>
                                    {
                                        viewMatch.memberName
                                    }
                                </h3>

                                <span>
                                    {
                                        viewMatch.memberId
                                    }
                                </span>

                                <p>
                                    {
                                        viewMatch.memberAge
                                    }{" "}
                                    Years •{" "}
                                    {
                                        viewMatch.memberGender
                                    }
                                </p>

                            </div>

                            <div className="match-heart">

                                <Heart
                                    size={28}
                                    fill="currentColor"
                                />

                                <strong>
                                    {
                                        viewMatch.matchPercentage
                                    }
                                    %
                                </strong>

                            </div>

                            <div className="match-profile-card">

                                <div className="match-large-avatar female-avatar">
                                    {viewMatch.matchedMemberName
                                        .charAt(0)
                                        .toUpperCase()}
                                </div>

                                <h3>
                                    {
                                        viewMatch.matchedMemberName
                                    }
                                </h3>

                                <span>
                                    {
                                        viewMatch.matchedMemberId
                                    }
                                </span>

                                <p>
                                    {
                                        viewMatch.matchedAge
                                    }{" "}
                                    Years •{" "}
                                    {
                                        viewMatch.matchedGender
                                    }
                                </p>

                            </div>

                        </div>

                        {/* MATCH INFORMATION */}

                        <div className="match-detail-section">

                            <h3>
                                Match Information
                            </h3>

                            <div className="match-detail-grid">

                                <MatchInfo
                                    label="Community"
                                    value={
                                        viewMatch.community
                                    }
                                />

                                <MatchInfo
                                    label="Sub Community"
                                    value={
                                        viewMatch.subCommunity
                                    }
                                />

                                <MatchInfo
                                    label="Caste"
                                    value={
                                        viewMatch.caste
                                    }
                                />

                                <MatchInfo
                                    label="Education"
                                    value={
                                        viewMatch.education
                                    }
                                />

                                <MatchInfo
                                    label="Profession"
                                    value={
                                        viewMatch.profession
                                    }
                                />

                                <MatchInfo
                                    label="Branch"
                                    value={
                                        viewMatch.branch
                                    }
                                />

                                <MatchInfo
                                    label="State"
                                    value={
                                        viewMatch.state
                                    }
                                />

                                <MatchInfo
                                    label="District"
                                    value={
                                        viewMatch.district
                                    }
                                />

                                <MatchInfo
                                    label="Marital Status"
                                    value={
                                        viewMatch.maritalStatus
                                    }
                                />

                                <MatchInfo
                                    label="Horoscope"
                                    value={
                                        viewMatch.horoscope
                                    }
                                />

                                <MatchInfo
                                    label="Match Status"
                                    value={
                                        viewMatch.status
                                    }
                                />

                                <MatchInfo
                                    label="Created Date"
                                    value={
                                        viewMatch.createdDate
                                    }
                                />

                            </div>

                        </div>

                        {/* SCORE */}

                        <div className="match-score-section">

                            <div className="match-score-title">

                                <span>
                                    Compatibility Score
                                </span>

                                <strong>
                                    {
                                        viewMatch.matchPercentage
                                    }
                                    %
                                </strong>

                            </div>

                            <div className="match-large-score-bar">

                                <span
                                    style={{
                                        width: `${viewMatch.matchPercentage}%`,
                                    }}
                                />

                            </div>

                        </div>

                        <div className="match-modal-footer">

                            <button
                                className="secondary-btn"
                                onClick={() =>
                                    setViewMatch(
                                        null
                                    )
                                }
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}

function MatchFilter({
    label,
    value,
    onChange,
    options,
}) {
    return (
        <div className="match-filter-field">

            <label>{label}</label>

            <div className="match-select-wrapper">

                <select
                    value={value}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                >

                    <option value="">
                        All {label}
                    </option>

                    {options.map((option) => (
                        <option
                            key={option}
                            value={option}
                        >
                            {option}
                        </option>
                    ))}

                </select>

                <ChevronDown size={15} />

            </div>

        </div>
    );
}

function MatchInfo({ label, value }) {
    return (
        <div className="match-info-item">

            <span>{label}</span>

            <strong>
                {value || "-"}
            </strong>

        </div>
    );
}

export default Matches;